import * as React from 'react';
import styled from 'styled-components';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const ModalHeader = ({ children, className, ...rest }: Props) => {
  return (
    <Header {...rest} className={className}>
      {children}
    </Header>
  );
};

const Header = styled.div`
  padding: ${({ theme }) => theme.spacing.medium}px;
  background-color: ${({ theme }) => theme.colors.elevated};
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  z-index: 2;
  overflow: hidden;
`;

export default ModalHeader;
